import { useRef } from "react";

import { landingRecruitData } from "../../../../models/landing/recruit/recruit.model";

import * as S from "./LandingPageRecruitOrganism.style";

export let recruitRef;
const LandingPageRecruitOrganism = ({ course }: { course: string }) => {
  recruitRef = useRef();
  const coursePeriod = {
    pm: "23.10.07(토) - 24.01.05(금)",
    mkt: "23/6/10(토) - 23/9/2(토)",
  };
  const courseMentoringTime = {
    pm: "10:00 am - 7:00 pm",
    mkt: "10:00 am - 6:00pm",
  };

  const renderPoints = (data, idx) => (
    <S.Point key={idx}>
      <S.Number>{idx + 1}</S.Number>
      <S.Text>
        <p>{data.title}</p>
        <S.TextDetail>{data.desc}</S.TextDetail>
      </S.Text>
    </S.Point>
  );
  const data = landingRecruitData(course);

  return (
    <S.Wrapper ref={recruitRef}>
      <S.Title>모집 개요</S.Title>
      <S.Cards>
        <S.Card big={false}>
          <S.Schedule>교육 시간</S.Schedule>
          <S.Detail>
            {coursePeriod[course]} <span>* 13주</span>
          </S.Detail>
          <S.SubTitle>
            매주 화요일, 목요일 <span>|</span>
            <p>팀 프로젝트</p>
          </S.SubTitle>
          <S.Info>8:00 pm - 11:00 pm</S.Info>
          <S.SubTitle>
            매주 토요일 <span>|</span>
            <p>화상 멘토링 및 특강</p>
          </S.SubTitle>
          <S.Info>{courseMentoringTime[course]}</S.Info>
        </S.Card>
        <S.Card big={true}>
          <S.Schedule>지원 절차</S.Schedule>
          <S.Points>
            {data.map((data, idx) => renderPoints(data, idx))}
          </S.Points>
        </S.Card>
      </S.Cards>
    </S.Wrapper>
  );
};

export default LandingPageRecruitOrganism;
